import _ from 'lodash';
import 'whatwg-fetch';
import objectAssign from 'object-assign';
import update from 'immutability-helper';
import toastr from 'toastr';
import * as types from '../constants/actionTypes';
import * as utils from './actionUtils';
import { push } from 'react-router-redux';
// import dateHelper from '../utils/dateHelper';

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}


// example of a thunk using the redux-thunk middleware
export function loadEvents() {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('events/',
      (result) => {dispatch(loadEventsSuccess(result));},
      (error) => {dispatch(loadEventsFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_EVENTS,
    });
  };
}

export function loadEventsSuccess(eventList) {
  return {
    type: types.LOAD_EVENTS_SUCCESS,
    eventList: eventList,
    eventListUpdated: Date.now(),
  };
}

export function loadEventsFail(error) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_EVENT_DETAILS_FAILURE,
      errors: error,
    });
  };
}

export function loadEventDetails(id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('events/' + id,
      (result) => {dispatch(loadEventDetailsSuccess(result));},
      (error) => {dispatch(loadEventsFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_EVENT_DETAILS,
    });
  };
}

export function loadEventDetailsSuccess(eventDetails) {
  return {
    type: types.LOAD_EVENT_DETAILS_SUCCESS,
    eventDetails: eventDetails,
    eventDetailsUpdated: Date.now(),
  };
}

export function updateEvent(eventDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('events/' + eventDetails.id, 'PUT', eventDetails,
      (result) => {dispatch(updateEventSuccess(result));},
      (result) => {dispatch(updateEventFail(result));},
      defaultDelay);

  };
}

export function createEvent(eventDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('events/', 'POST', eventDetails,
      (result) => {dispatch(createEventSuccess(result));},
      (result) => {dispatch(updateEventFail(result));},
      defaultDelay);
  };
}

export function updateEventSuccess(eventDetails) {
  return function(dispatch) {
    toastr.success('Lagret');
    dispatch({
      type: types.LOAD_EVENT_DETAILS_SUCCESS,
      eventDetails: eventDetails,
      eventDetailsUpdated: Date.now(),
    });
  };
}

export function createEventSuccess(eventDetails) {
  return function(dispatch) {
    toastr.success('Opprettet');
    dispatch(push('/arrangement/' + eventDetails.id + '/rediger'));
    dispatch({
      type: types.LOAD_EVENT_DETAILS_SUCCESS,
      eventDetails: eventDetails,
      eventDetailsUpdated: Date.now(),
    });
  };
}

export function updateEventFail(errors) {
  return function(dispatch) {
    toastr.warning('Lagreing feilet');
    dispatch({
      type: types.LOAD_EVENT_DETAILS_FAILURE,
      errors: errors,
    });
  };
}

export function deleteEvent(id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.deleteData('events/' + id, () => {
      dispatch(push('/arrangement'));
      toastr.success('Arrangement slettet');
    }, defaultDelay);
  };
}

export function updateEventImage(event_id, image) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    let data = new FormData();
    data.append('image', image);
    utils.sendFormData('events/' + event_id + '/image', 'PUT', data,
      (result) => {dispatch(updateEventImageSuccess(result));},
      (result) => {dispatch(updateEventFail(result));},
      defaultDelay);
  };
}

export function copyEvent(eventDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    toastr.info('Kopierer arrangement');
    utils.sendData('events/' + eventDetails.id + '/copy', 'POST', {},
      (result) => {dispatch(createEventSuccess(result));},
      (result) => {dispatch(updateEventFail(result));},
      defaultDelay);
  };
}

export function updateEventImageSuccess(result) {
  return function(dispatch, getState) {
    toastr.success('Bilde oppdatert');
    let eventDetails = objectAssign({}, getState().events.eventDetails);
    eventDetails.image = result.image;
    eventDetails.image_thumbnail = result.image_thumbnail;
    dispatch({
      type: types.LOAD_EVENT_DETAILS_SUCCESS,
      eventDetails: eventDetails,
      eventDetailsUpdated: Date.now(),
    });
  };
}

// Event registration settings
export function loadEventTeamSettings(eventId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('events/' + eventId + '/teams',
      (result) => {dispatch(loadEventTeamSettingsSuccess(result));},
      (error) => {dispatch(loadEventTeamSettingsFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_EVENT_TEAM_SETTINGS,
    });
  };
}

export function loadEventTeamSettingsSuccess(list) {
  let listWithErrors = _.map(list, function(team) {
       return _.extend({}, team, {errors: []});
  });
  return {
    type: types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS,
    teamList: listWithErrors,
    teamListUpdated: Date.now(),
  };
}

export function loadEventTeamSettingsFail() {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_EVENT_TEAM_SETTINGS_FAILURE,
    });
  };
}


export function addNewTeam(eventId) {
  return function (dispatch, getState) {
    let teamList = objectAssign([], getState().events.teamList);
    let identifier = '_' + Math.random().toString(36).substr(2, 20);
    teamList.push({event: eventId,
      team_categories: [],
      errors: {},
      identifier: identifier});
    dispatch({
      type: types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS,
      teamList: teamList,
      teamListUpdated: Date.now(),
    });
  };
}

export function copyTeam(team) {
  return function (dispatch, getState) {
    let teamList = objectAssign([], getState().events.teamList);

    function updateNested(items) {
      // console.log(items);
      return _.map(items, (item) => {
        return update(item, {
          "id": {$set: undefined},
          "identifier": {$set: '_' + Math.random().toString(36).substr(2, 20)},
          "member_categories": {$apply: updateNested},
        })
      })
    }

    function copiedName(item) {
      return item + ' (Kopi)';
    }

    function copiedSlug(item) {
      return item + '-kopi';
    }

    function updatePosition(item) {
      return item + 1;
    }

    let newTeam = update(team, {
      "name": {$apply: copiedName},
      "slug": {$apply: copiedSlug},
      "position": {$apply: updatePosition},
      "id": {$set: undefined},
      "identifier": {$set: '_' + Math.random().toString(36).substr(2, 20)},
      "team_categories": {
        $apply: updateNested
      }
    });
    // console.log(team, newTeam, team === newTeam);

    // teamList.push(newTeam);
    dispatch(copyTeamCreate(newTeam));
  };
}

export function copyTeamCreate(details) {
  return function (dispatch) {
    toastr.info('Lagrer');
    dispatch(utils.beginAjaxCall());
    utils.sendData('events/' + details.event + '/teams/',
      'POST', details,
      (result) => {dispatch(loadEventTeamSettings(details.event));},
      (result) => {dispatch(loadEventTeamSettingsFail(details.event));},
      defaultDelay);

  };
}

export function createTeam(details) {
  return function (dispatch) {
    toastr.info('Lagrer');
    dispatch(utils.beginAjaxCall());
    utils.sendData('events/' + details.event + '/teams/',
      'POST', details,
      (result) => {dispatch(updateTeamSuccess(result));},
      (result) => {dispatch(updateTeamFail(result));},
      defaultDelay);

  };
}

export function updateTeam(details) {
  return function (dispatch) {
    toastr.info('Lagrer');
    dispatch(utils.beginAjaxCall());
    utils.sendData('events/' + details.event + '/teams/' + details.id,
      'PUT', details,
      (result) => {dispatch(updateTeamSuccess(result));},
      (result) => {dispatch(updateTeamFail(result, details.identifier));},
      defaultDelay);

  };
}

export function updateTeamSuccess(details) {
  return function(dispatch, getState) {
    let teamList = objectAssign([], getState().events.teamList);
    let detailsWithError = _.extend({}, details, {errors: []});
    let index = _.indexOf(teamList, _.find(teamList, {id: detailsWithError.id}));
    if (index != -1) {
      teamList.splice(index, 1, detailsWithError);
    } else if(details.position) {
      teamList.splice(details.position, 0, detailsWithError);
    } else {
      index = _.indexOf(teamList, _.find(teamList, {slug: detailsWithError.slug}));
      teamList.splice(index, 1, detailsWithError);
    }

    toastr.success('Lagret');
    // dispatch({
    //   type: types.UPDATE_EVENT_TEAM_SETTINGS_SUCCESS,
    // });
    dispatch({
      type: types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS,
      teamList: teamList,
      teamListUpdated: Date.now(),
    });
  };
}

export function updateTeamFail(errors, identifier) {
  return function(dispatch) {
    toastr.warning('Lagreing feilet');
    dispatch({
      type: types.UPDATE_EVENT_TEAM_SETTINGS_FAILURE,
      errors: {[identifier]: errors},
    });
  };
}

export function deleteTeam(details, teamIndex) {
  return function (dispatch) {
    if(details.id) {
      utils.deleteData('events/' + details.event + '/teams/' + details.id, () => {
        dispatch(deleteTeamSuccess(details, teamIndex));
      }, defaultDelay);
    } else {
      dispatch(deleteTeamSuccess(details, teamIndex));
    }
  };
}

export function deleteTeamSuccess(details, teamIndex) {
  return function(dispatch, getState) {
    toastr.success('Slettet');
    let teamList = objectAssign([], getState().events.teamList);
    teamList.splice(teamIndex, 1);
    dispatch({
      type: types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS,
      teamList: teamList,
      teamListUpdated: Date.now(),
    });
  };
}

// export function addNewTeamMemberCategory(teamDetails, teamIndex, categoryIndex) {
//   return function (dispatch, getState) {
//     teamDetails = update(teamDetails, {team_categories: {[categoryIndex]: {
//         member_categories: {
//           $push: [{errors:[], _destroy: false, identifier: Math.random()}]
//         }
//       }}}
//     );
//     let teamList = update(getState().events.teamList, {$splice: [[teamIndex, 1, teamDetails]]});
//     dispatch({
//       type: types.LOAD_EVENT_TEAM_SETTINGS_SUCCESS,
//       teamList: teamList,
//       teamListUpdated: Date.now(),
//     });
//   };
// }

// export function createEvent(eventDetails) {
//   return function (dispatch) {
//     dispatch(utils.beginAjaxCall());
//     utils.sendData('events/', 'POST', eventDetails,
//       (result) => {dispatch(createEventSuccess(result));},
//       (result) => {dispatch(updateEventFail(result));},
//       defaultDelay);
//   };
// }

// export function createEventSuccess(eventDetails) {
//   return function(dispatch) {
//     toastr.success('Opprettet');
//     dispatch(push('/arrangement/' + eventDetails.id + '/rediger'));
//     dispatch({
//       type: types.LOAD_EVENT_DETAILS_SUCCESS,
//       eventDetails: eventDetails,
//       eventDetailsUpdated: Date.now(),
//     });
//   };
// }



/** WEBPACK FOOTER **
 ** ./src/actions/eventActions.js
 **/